<template>
  <main>
    <div class="container-fluid message page-note">
      <TopTemplate>
        <template #left-element>
          <div v-if="notesExamList">
            <h3>{{ $t("common.notesExam") }} {{ fieldName }}</h3>
            <p class="mb-0">Classe : {{ className }}</p>
            <p class="mb-0">Période : {{ periodTitle }}</p>
          </div>
        </template>
        <template v-slot:right-element>
          <div class="d-flex">
            <a @click="navigateToDetails" class="btn btn-outline-primary button margin-r" :disabled="loading">
              <i class="arrow left"></i>
              {{ $t("button.retour") }}
            </a>
            <button v-if="editPage" class="btn button btn-primary margin-r" @click="updateNotes('save')" :disabled="loading || blockButton">
              {{ $t("button.save") }}
            </button>
            <template v-else>
              <router-link v-if="id && isEditable" class="btn button btn-primary margin-r" :to="{name: 'EditNotesExamen', params: {id: id}}" :disabled="loading">
                {{ $t("button.edit") }}
              </router-link>
              <button v-if="isEditable" class="btn button btn-primary" @click="updateNotes('valid')" :disabled="loading || blockButton">
                {{ $t("button.validate") }}
              </button>
            </template>
          </div>
        </template>
      </TopTemplate>

      <div v-if="loading" class="card mt-2 text-center d-block pt-2 pb-24">
        <div class="spinner-border text-info" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <div v-if="!loading && notesExamList" class="table teacher table-note notes-exam">
        <div class>
          <div class="row">
            <div class="col-md-12">
              <div class="table__wrapper table-responsive-vertical table-responsive">
                <table class="table">
                  <thead>
                    <template v-if="languageCategory">
                      <tr>
                        <th class="w-20 bg-hidd"></th>
                        <th :colspan="coursesFr.length" class="border-header">Francais</th>
                        <th colspan="2" class="border-header">Anglais</th>
                        <th class="bg-hidd"></th>
                        <th class="w-20 bg-hidd border-r"></th>
                      </tr>
                      <tr>
                        <th class="w-20" :class="{'border-child': languageCategory}"></th>
                        <th v-for="(course_fr, i) in coursesFr" :key="course_fr.id + 'fr'" :class="{'border-child': i == coursesFr.length - 1}">
                          {{ course_fr.name }}
                        </th>
                        <th v-for="course_en in coursesEn" :key="course_en.id + 'en'">{{ course_en.name }}</th>
                        <th class="border-l">Moyenne</th>
                        <th class="w-20 border-x">Remarque Prof</th>
                      </tr>
                    </template>
                    <tr v-else class="full-border">
                      <th class="w-20"></th>
                      <th v-for="item in notesExamList.courses">{{ item.name }}</th>
                      <th class="border-l">Moyenne</th>
                      <th class="w-20 border-x">Remarque Prof</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(ele, i_field) in notesExamData" :key="ele.id + i_field + 'notes'">
                      <td class="w-20" :class="{'border-child': languageCategory}">
                        {{ ele.student_full_name }}
                      </td>
                      <template v-if="languageCategory">
                        <td
                          v-for="(field_fr, index) in filterCourses(ele.student_field_course, 'fr')"
                          :key="field_fr.id + 'courseFr'"
                          :class="{'border-child': index == filterCourses(ele.student_field_course, 'fr').length - 1}"
                        >
                          <input
                            v-if="editPage"
                            class="note-input"
                            :class="{'is-invalid': field_fr.validateRangeError}"
                            :value="notesFields(field_fr, coursesFr, 'edit')"
                            @input="setNotesFields(field_fr, coursesFr, index, $event)"
                            @keypress="validateNumeric($event, index)"
                            type="text"
                          />
                          <p v-else>
                            <span :class="getClassObject(field_fr)">{{ notesFields(field_fr, coursesFr, "show") }}</span>
                          </p>
                          <p v-if="field_fr.validateRangeError" class="invalid-feedback">{{ $t("validation.numericNote") }}</p>
                        </td>
                        <td v-for="(field_en, index) in filterCourses(ele.student_field_course, 'en')" :key="field_en.id + 'courseEn'">
                          <input
                            v-if="editPage"
                            class="note-input"
                            :class="{'is-invalid': field_en.validateRangeError}"
                            :value="notesFields(field_en, coursesEn, 'edit')"
                            @input="setNotesFields(field_en, coursesEn, index, $event)"
                            @keypress="validateNumeric($event, index)"
                            type="text"
                          />
                          <p v-else>
                            <span :class="getClassObject(field_en)">{{ notesFields(field_en, coursesEn, "show") }}</span>
                          </p>
                          <p v-if="field_en.validateRangeError" class="invalid-feedback">{{ $t("validation.numericNote") }}</p>
                        </td>
                      </template>
                      <template v-else>
                        <td v-for="(field, i_courses) in ele.student_field_course" :key="field.id + 'courses' + i_courses">
                          <input
                            v-if="editPage"
                            class="note-input"
                            :class="{'is-invalid': field.validateRangeError}"
                            :value="notesFields(field, notesExamList.courses, 'edit')"
                            @input="setNotesFields(field, notesExamList.courses, i_courses, $event)"
                            @keypress="validateNumeric($event, i_courses)"
                            type="text"
                          />
                          <p v-else>
                            <span :class="getClassObject(field)">{{ notesFields(field, notesExamList.courses, "show") }}</span>
                          </p>
                          <p v-if="field.validateRangeError" class="invalid-feedback">{{ $t("validation.numericNote") }}</p>
                        </td>
                      </template>
                      <td class="border-l">
                        <p>{{ ele.field_average || "-" }}</p>
                      </td>
                      <td class="w-20 border-x">
                        <textarea v-if="editPage" v-model="ele.field_remark" type="text" class="remark_text" placeholder="" />
                        <p v-else>{{ ele.field_remark }}</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!editPage" class="d-flex align-items-center">
          <div class="legend"></div>
          <p class="m-0">{{ $t("common.lowerNote") }}</p>
        </div>
        <div v-if="!editPage" class="d-flex align-items-center">
          <div class="legend green-color"></div>
          <p class="m-0">{{ $t("common.bestNote") }}</p>
        </div>
        <button v-if="editPage" class="btn button btn-primary margin-l-auto" @click="updateNotes('save')" :disabled="loading || blockButton">
          {{ $t("button.save") }}
        </button>
      </div>
      <div v-else-if="!loading && !notesExamList" class="block-no-data">
        <p>{{ $t("common.noData") }}</p>
      </div>
    </div>
  </main>
</template>

<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import NoteService from "../../services/note.service";
import vSelect from "vue-select";

export default {
  components: {
    TopTemplate,
    "v-select": vSelect,
  },
  setup() {
    return {};
  },
  data() {
    return {
      loading: false,
      notesExamList: null,
      coursesFr: [],
      coursesEn: [],
      id: null,
      blockButton: false,
      notesExamData: [],
    };
  },
  computed: {
    periodTitle() {
      return `${this.notesExamList.period?.period} - ${this.notesExamList.school_session?.name}` || "";
    },
    className() {
      return this.notesExamList.class_name || "";
    },
    fieldName() {
      return this.notesExamList.field?.name_fr || "";
    },
    languageCategory() {
      return this.notesExamList.field?.id == 7;
    },
    editPage() {
      return this.$route.name == "EditNotesExamen";
    },
    isEditable() {
      return (this.notesExamList && this.notesExamList.school_session?.status) || false;
    },
  },
  mounted() {
    this.id = this.$route.params.id;
    this.getListClass(this.id);
  },
  methods: {
    validateNumeric(event, index) {
      let max = 20;
      let note = parseFloat(event.target.value.replace(",", "."));
      if (note > max) {
        event.preventDefault();
      } else {
        let sanitizedValue = event.target.value.replace(/[^0-9,.ADad]/g, "").toUpperCase();
        event.target.value = sanitizedValue;
      }
    },
    async getListClass(id) {
      try {
        this.loading = true;
        const res = await NoteService.getNotesExamList(id);
        this.notesExamList = res.data.data;
        this.coursesFr = this.filterCourses(this.notesExamList.courses, "fr");
        this.coursesEn = this.filterCourses(this.notesExamList.courses, "en");
        this.notesExamData = this.formatData(this.notesExamList.student_field);
      } catch (err) {
        console.error("error : ", err);
      } finally {
        this.loading = false;
      }
    },
    notesFields(field, courses_list, type) {
      // return field.report_mark < 0 ? "A" : field.course_id == courses_list[index]?.id && field.report_mark ? parseFloat(field.report_mark) : null;
      const element = courses_list.find((item) => field.course_id === item.id && field.report_mark !== undefined && field.report_mark !== null);
      if (element) {
        return field.report_mark == -1 ? "A" : field.report_mark == -2 ? "D" : parseFloat(field.report_mark);
      } else {
        return type === "edit" ? null : "-";
      }
    },
    setNotesFields(field, courses_list, index, event) {
      const inputValue = event.target.value;

      if (inputValue.trim() === "") {
        field.report_mark = null;
        field.validateRangeError = false;
        return;
      }

      const parsedValue = parseFloat(inputValue);
      const upperCaseValue = inputValue.toUpperCase();
      field.report_mark = upperCaseValue === "A" ? -1 : upperCaseValue === "D" ? -2 : isNaN(parsedValue) ? null : parsedValue;
      field.validateRangeError = parsedValue < 0 || parsedValue > 20;
    },
    maxMinFieldColor(field, array) {
      const match = array.find((item) => field.course_id === item.course_id && field.report_mark === item.max_mark);
      if (match) {
        return "max-note";
      }

      const minMatch = array.find((item) => field.course_id === item.course_id && field.report_mark === item.min_mark);
      if (minMatch) {
        return "min-note";
      }

      return "";
    },
    getClassObject(field) {
      const maxMinColor = this.maxMinFieldColor(field, this.notesExamList.course_max_min_mark);
      return maxMinColor ? {[maxMinColor]: true} : {};
    },
    filterCourses(data, lang) {
      const courseType = lang === "fr" ? 1 : 2;
      return data.filter((element) => element.course_type == courseType);
    },
    formatData(array) {
      return array.map((ele) => {
        if (Array.isArray(ele.student_field_course)) {
          ele.student_field_course.forEach((item) => {
            if (typeof item.validateRangeError === "undefined") {
              item.validateRangeError = false;
            }
          });
        }
        return ele;
      });
    },
    async updateNotes(action) {
      const Swal = require("sweetalert2");
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-confirm  btn-primary",
          cancelButton: "btn  btn-cancel  btn-outline-primary",
        },
        buttonsStyling: false,
        showCloseButton: true,
      });
      const EMPTY_FIELD_WARNING = this.$t("error.emptyFieldWarning");
      const CONFIRM_MODIFS = this.$t("common.confirmModifs");
      const DELET_IT = this.$t("common.deletIT");
      const NO_CANCEL = this.$t("common.noCancel");
      const EMPTY_FIELD_VALID = this.$t("error.emptyFieldValid");
      const CONFIRM_VALID = this.$t("common.confirmValid");
      const data = {
        class_field_status: action == "save" ? this.notesExamList.class_field_status : 3,
        field_id: this.notesExamList.field.id,
        student_field: this.notesExamData,
      };
      const hasEmptyField = this.notesExamList?.additional_field === 0 && this.notesExamData.some((element) => element.student_field_course.some((item) => item.report_mark!==0 && !item.report_mark));
      const hasErrorField = this.notesExamData.some((element) => element.student_field_course.some((item) => item.validateRangeError));
      this.blockButton = true;
      try {
        const showAlertAndSave = async (title) => {
          const result = await swalWithBootstrapButtons.fire({
            title: title,
            icon: "warning",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: DELET_IT,
            cancelButtonText: NO_CANCEL,
            reverseButtons: true,
          });

          if (result.isConfirmed) {
            await NoteService.updateNotesExam(this.id, data);
            action == "save" ? this.NotesExamPage() : this.domainListPage();
          }
        };
        if (hasErrorField) {
          const firstErrorField = document.querySelector(".is-invalid");
          if (firstErrorField) {
            firstErrorField.scrollIntoView({behavior: "smooth", block: "center"});
          }
        } else if (hasEmptyField) {
          action == "save" ? await showAlertAndSave(EMPTY_FIELD_WARNING) : await swalWithBootstrapButtons.fire(EMPTY_FIELD_VALID, "", "warning");
        } else {
          action == "save" ? await showAlertAndSave(CONFIRM_MODIFS) : await showAlertAndSave(CONFIRM_VALID);
        }
      } catch (err) {
        console.error("erreur update note : ", err);
      } finally {
        this.blockButton = false;
      }
    },
    navigateToDetails() {
      this.editPage ? this.NotesExamPage() : this.domainListPage();
    },
    NotesExamPage() {
      this.$router.push({name: "NotesExamen", params: {id: this.id}});
      this.getListClass(this.id);
    },
    domainListPage() {
      this.$store.commit("SET_PERIOD_ID", this.notesExamList?.period?.id);
      this.$router.push({name: "DomainList", params: {id: this.notesExamList.class_id}});
    },
  },
};
</script>

<style lang="scss" scoped></style>
